import(/* webpackMode: "eager" */ "/opt/buildhome/repo/web/src/app/template.tsx");
